import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {} from 'module';
import {Observable} from 'rxjs/Observable';
import {Headers, Http} from '@angular/http';
import {ApiEvsService} from '../../../../../common/services/ApiEvs.service';

@Injectable()
export class ImportCratingService {
  headers: Headers;
  url = environment.qrcode_url;
  urlBoxImport = environment.qrcode_support;

  constructor(
    private http: Http,
    private http2: ApiEvsService
  ) {
    const token = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  // @ts-ignore
  boxImportValidate(file?: any, isEnvLive: boolean, active: boolean = false): Observable<any> {
    this.headers.delete('Content-Type');
    if (localStorage.getItem('Access-Token')) {
      this.headers.set('authorization', localStorage.getItem('Access-Token'));
    }
    let formData = new FormData();
    formData.append('file', file, file.name);
    const url = isEnvLive ? this.urlBoxImport : this.url;
    const activeParam = active ? '?active=true' : '';
    return this.http
      .post(`${url}/box/import/validate${activeParam}`, formData, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  // boxImportValidateLive(file?: any): Observable<any> {
  //   this.headers.delete('Content-Type');
  //   if (localStorage.getItem('Access-Token')) {
  //     this.headers.set('authorization', localStorage.getItem('Access-Token'));
  //   }
  //   let formData = new FormData();
  //   formData.append('file', file, file.name);
  //   return this.http
  //     .post(`${this.urlBoxImport}/box/import/validate`, formData, {headers: this.headers})
  //     .map((res) => {
  //       return res.json();
  //     })
  //     .catch((error: any) => {
  //       throw error.json();
  //     });
  // }

  // @ts-ignore
  boxImport(file?: any, isEnvLive: boolean, active: boolean = false): Observable<any> {
    this.headers.delete('Content-Type');
    if (localStorage.getItem('Access-Token')) {
      this.headers.set('authorization', localStorage.getItem('Access-Token'));
    }
    const url = isEnvLive ? this.urlBoxImport : this.url;
    const activeParam = active ? '?active=true' : '';
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${url}/box/import${activeParam}`, formData, {headers: this.headers}).map((res) => {
      return res.json();
    })
      .catch((error: any) => {
        throw error.json();
      })
  }
  // Import đóng thùng lẻ
  boxImportBoxSingle(file?: any): Observable<any> {
    this.headers.delete('Content-Type');
    if (localStorage.getItem('Access-Token')) {
      this.headers.set('authorization', localStorage.getItem('Access-Token'));
    }
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${this.url}/box/import-active`, formData, {headers: this.headers}).map((res) => {
      return res.json();
    })
      .catch((error: any) => {
        throw error.json();
      })
  }

  // boxImportLive(file?: any): Observable<any> {
  //   this.headers.delete('Content-Type');
  //   if (localStorage.getItem('Access-Token')) {
  //     this.headers.set('authorization', localStorage.getItem('Access-Token'));
  //   }
  //   let formData = new FormData();
  //   formData.append('file', file, file.name);
  //   return this.http.post(`${this.urlBoxImport}/box/import`, formData, {headers: this.headers}).map((res) => {
  //     return res.json();
  //   })
  //     .catch((error: any) => {
  //       throw error.json();
  //     })
  // }

  getNotifi(id): Observable<any> {
    return this.http
      .get(`${this.url}/box/import/result/detail/${id}`, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  // getExcel(url): Observable<any> {
  //   return this.http
  //     .get(url, {headers: this.headers, responseType: 'blob'})
  //     .map((res) => {
  //       return res.json();
  //     })
  //     .catch((error: any) => {
  //       throw error.json();
  //     });
  // }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/import-crating/services/import-crating.services.ts